// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// React components
import Box from "components/Box";
import Badge from "components/Badge";
import CustomTypography from "components/CustomTypography";

// Presentation page components
import ExampleCard from "pages/Presentation/components/ExampleCard";

// Data
import data from "pages/Presentation/sections/data/chatBotData";

function ChatBotsBlock() {
  const renderData = data.map(({ title, description, items }) => (
    <Grid container spacing={3} sx={{ mb: 10 }} key={title}>
      <Grid item xs={12} lg={3}>
        <Box position="sticky" top="100px" pb={{ xs: 2, lg: 6 }}>
          <CustomTypography variant="h3" fontWeight="bold" mb={1}>
            {title}
          </CustomTypography>
          <CustomTypography variant="body2" fontWeight="regular" color="secondary" mb={1} pr={2}>
            {description}
          </CustomTypography>
        </Box>
      </Grid>
      <Grid item xs={12} lg={9}>
        <Grid container spacing={3}>
          {items.map(({ image, name, count, route, pro }) => (
            <Grid item xs={12} md={4} sx={{ mb: 2 }} key={name}>
              <Link to={pro ? "/" : route}>
                <ExampleCard image={image} name={name} count={count} pro={pro} />
              </Link>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  ));

  return (
    <Box component="section" my={6} py={6}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          flexDirection="column"
          alignItems="center"
          sx={{ textAlign: "center", my: 6, mx: "auto", px: 0.75 }}
        >
          <Badge variant="contained" color="info" badgeContent="Multiple combinations" container sx={{ mb: 2 }} />
          <CustomTypography variant="h2" fontWeight="bold">
            Great variety of chatbots
          </CustomTypography>
          <CustomTypography variant="body1" color="text">
            Tell us your business need and we&apos;ll find the perfect chatbot for you.
            <br />
            If we don&apos;t already have it, we&apos;ll build it for you.
          </CustomTypography>
        </Grid>
      </Container>
      <Container sx={{ mt: 6 }}>{renderData}</Container>
    </Box>
  );
}

export default ChatBotsBlock;
